import { TUserSendEmailData, TUserSendEmailPeerSupportOrMemberCare } from '@/types/User.types';
import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';

export const sendEmail = async (
  peerSupportOrMemberCare: TUserSendEmailPeerSupportOrMemberCare,
  userSendEmailData: TUserSendEmailData,
): Promise<{ success: boolean }> => {
  const { data } = await api.post(apiPaths.contact.byRecipient(peerSupportOrMemberCare), userSendEmailData);
  return data.data;
};

export const contractSalesPost = async (contractId: string, subject: string, message: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(apiPaths.contact.contractSales, {
    contractId,
    subject,
    message,
  });

  return data.data;
};
